import React from 'react';
export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16">
      <h1 className="font-display text-3xl font-semibold">Terms of use</h1>
      <div className="mt-6 space-y-4 text-sm">
        <p>By accessing Aakash Drishti you agree to the following terms. The platform provides probabilistic satellite-derived indications for infrastructure monitoring and is not a substitute for statutory dam-safety inspection, SCADA, IoT or physical surveillance.</p>
        <p>Aakash Drishti does not have emergency-action authority. Alerts require analyst or field verification per organisational SOP prior to any operational action.</p>
      </div>
    </div>
  );
}
